export const hasStorageAccess = async (): Promise<boolean> => {
  if (isStorageAccessSupportedByBrowser()) {
    return await document.hasStorageAccess()
  }
  return true
}

export const requestStorageAccess = async (): Promise<void> => {
  return await document.requestStorageAccess()
}

// https://udn.realityripple.com/docs/Web/API/Document/hasStorageAccess
const isStorageAccessSupportedByBrowser = (): boolean =>
  typeof document.hasStorageAccess === 'function' && typeof document.requestStorageAccess === 'function'
